<template>
    <div style="position: relative">
        <div style="overflow: auto;height: calc(100%);" dir="rtl" @scroll="getscroll($event)">
            <div dir="ltr">

                <!-- <div style="margin-top: 10px;margin-left: 5px;position: fixed;margin-top: -40px;z-index: 3;">
                    <img src="../assets/image/zlbbanner.png">
                </div> -->
                <template v-if="!jumptype">
                    <!-- <div style="margin-top: 10px;margin-left: 5px;">
                        <img src="../assets/image/zlbbanner.png">
                    </div> -->

                    <div style="position: relative;min-height:100%">
                        <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
                        :src="`https://aiplugin.5118.com/Pluginstat/?p=SofaSniper&v=${version}`"
                        style="width: 0; height: 0; position: fixed; transform: translateY(-9999px);"></iframe>

                        <div v-if="version.replace(/\./gi, '') < 203">
                            <div>
                                <div class="row" style="margin: 10px 0;">
                                    <div class="_sofasniper_title" style="margin-top: 100%;text-align: center;">
                                        <p style="font-size:16px;padding-bottom: 10px;"><strong>版本过低</strong></p>
                                        <p>运行占楼宝需【2.0.3】版本以上</p>
                                        <p>您当前版本为【{{version}}】<br>如需使用该功能请升级您的插件</p>
                                        <p style="padding-top: 10px;"><button style="padding: 3px 15px;" class="btn">
                                            <a href="https://tool.5118.com/download" target="_Blank"><span style="color:#fff">我要升级</span></a></button></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="!projectshow" class="page">
                                <div>
                                    <div class="row" style="margin: 10px 0;">
                                        <div class="_sofasniper_title" style="margin-top: 100%;text-align: center;">
                                            <p style="font-size:16px;padding-bottom: 10px;"><strong>暂无项目</strong></p>
                                            <p>新建项目来获取数据，可监控知乎平台</p>
                                            <p>的帖子数据，方便您这边直接操作回帖</p>
                                            <p style="padding-top: 10px;"><button @click="jumpproject(1)" style="padding: 3px 15px;" class="btn">新建项目</button></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="page">
                                <div>
                                    <div class="row" style="margin: 10px 0;">
                                        <div class="_sofasniper_title">
                                            <span style="font-size: 14px;position: absolute;padding-top: 3px;">
                                                <strong>占楼宝项目列表</strong>
                                            </span>
                                            <span style="float: right;">
                                                <button @click="jumpproject(1)" class="btn"><img style="vertical-align: sub;" src="../assets/image/jia.png">新建</button>
                                                <button @click="jumpproject(2)" class="btn"><img style="vertical-align: sub;
                                                padding-right: 3px;" src="../assets/image/setup1.png">管理</button>
                                            </span>

                                        </div>
                                    </div>
                                    <div class="row" style="margin: 10px 0;padding-top: 10px;">
                                        <div v-for="(item,index) in catalogList" class="_sofasniper_list">
                                            <a @click="allgetdata(item.ProjectID,item.ProjectName,'',item.MonitorStatus)">
                                                <p class="_projcet_name"><strong>{{item.ProjectName}}</strong></p>
                                                <p class="_project_num">采集：{{item.OldCount}}条</p>
                                                <span v-if="getrowcount(item.ProjectID)>0" class="_project_msg"
                                                    :class="{active:getrowcount(item.ProjectID)>0}"
                                                    style="margin-left: 130px;margin-top: -28px;">发现{{getrowcount(item.ProjectID)}}条</span>
                                                <span v-else class="_project_msg" :class="{active:item.MonitorStatus===0}">{{getstatus(item.MonitorStatus,item.Step,item.ProjectID)}}</span>
                                                <span style="position: absolute;margin-left: 190px;margin-top: -30px;">
                                                <img style="position: absolute;margin-top: 3px;" src="../assets/image/right.png"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-loading="true" style="width:100%;height:50vh;position: relative;" v-if="showprojloading"></div>
                </template>

                <template v-if="jumptype">
                    <div style="position: relative">

                        <div style="margin: 10px 0;position: relative;">

                            <div id="titles" style="position: fixed;width: 255px;margin-top: -150px;background-color: #fff;z-index: 2;">
                                <!-- <div style="margin-top: 10px;margin-left: 5px;">
                                    <img src="../assets/image/zlbbanner.png">
                                </div> -->
                                <div class="page" style="padding-bottom: 20px;margin-top: 10px;">
                                    <a @click="gobackmain()">
                                        <span><img style="position: absolute;margin-top: 4px;" src="../assets/image/left.png"></span>
                                        <span style="margin-left: 20px;font-size: 15px;"><strong>{{CatalogName}}</strong></span>
                                    </a>
                                    <span style="float: right;">
                                        <button @click="jumpproject(3)" style="padding-left: 8px;" class="btn">
                                            <img style="vertical-align: sub;padding-right: 3px;" src="../assets/image/setup1.png">设置</button>
                                    </span>
                                </div>
                                <div v-if="optionstatrs" style="position:fixed;background-color: #169c07;
                                padding-bottom: 10px;padding-top: 5px;text-align: center;margin-top: -55px;
                                width:253px;margin-left:1px;z-index: 1;">
                                    <span style="color: white;padding: 5px 30px;border-radius: 10px;font-size: 13px;">
                                        {{optionsmsg}}</span>
                                </div>

                                <div class="stab">

                                    <ul class="tab">
                                        <li class="tab-item" @click="showType=item.code" :class="{active:showType===item.code}"
                                            v-for="(item,index) in tabList" :key="index">
                                            {{item.name}}
                                            <div>({{getcatalognumber(item.code)}})</div>
                                        </li>
                                    </ul>
                                    <div style="margin-left: 4px;padding-top: 10px;padding-bottom: 10px;">
                                        <input type="text" title="关键词" class="input" style="width: 58%;" @ placeholder="请输入查询词..." v-model="keyword"
                                            @keyup.enter="checkkeywords()">
                                        <a href="javascript:" style="position: absolute;right: 110px;top: 114px;" @click="checkkeywords">
                                            <img src="../assets/image/lupita.png" style="width: 16px">
                                        </a>
                                        <span title="刷新数据" style="margin-left: 4px;" class="newbtn" @click="checkrefresh()"><a><img src="../assets/image/refresh.png"></a></span>
                                        <span title="设置所有监控数据为已读" style="margin-left: 37px;" class="newbtn" @click="allread()"><a><img src="../assets/image/correct.png"></a></span>
                                        <span title="筛选数据" style="margin-left: 70px;" class="newbtn" @click="sofasearch()"><a><img src="../assets/image/funnel.png"></a></span>

                                    </div>
                                    <div v-if="projectstatus==2" style="padding-bottom: 10px;padding-top: 5px;text-align: center;" class="page">
                                        <span style="background-color: red;color: white;padding: 5px 5px;border-radius: 10px;">
                                            该项目已到期且自动停止更新，您可<a @click="jumpproject(4)"><span style="text-decoration: underline;color: white;">续费</span></a></span>
                                    </div>
                                    <div v-if="projectstatus==0" style="padding-bottom: 10px;padding-top: 5px;text-align: center;" class="page">
                                        <span style="background-color: red;color: white;padding: 5px 25px;border-radius: 10px;">
                                            该项目还未付费，<a @click="jumpproject(4)"><span style="text-decoration: underline;color: white;">我要付费</span></a></span>
                                    </div>

                                    <div v-if="getrowcount(catalogtype)>0" style="padding-bottom: 10px;padding-top: 5px;text-align: center;" class="page">
                                        <span style="background-color: #f49307;color: white;padding: 5px 30px;border-radius: 10px;">
                                            <a @click="checkrefresh()"><span style="color: white;">发现{{getrowcount(catalogtype)}}条未读知乎数据</span></a></span>
                                    </div>
                                    <!-- <div class="dotted-line"></div> -->
                                </div>
                            </div>

                            <div class="stab" style="margin-top: 150px;">

                                <SofaScr v-if="showsofasearch" v-on:listenScreenEvent='ScreenClose' v-on:listenSendmsgEvent="SendScreenMsg"></SofaScr>
                                <div v-else >
                                    <div v-if="NoList">
                                        <div v-for="(item,index) in ContentList" @mouseenter="showoperation(index)"
                                        @mouseleave="closeoperation(index)" class="artlist">
                                            <p class="page">
                                                <span style="padding-right:5px"><img class="headerimg" :src="item.HeaderImg"><img v-if="filter(item.Setting,'unread')" class="readimg" src="../assets/image/point.png"></span>
                                                <span class="ctitle" style="textOverflow: ellipsis;whiteSpace: nowrap;"
                                                :class="{isread:!filter(item.Setting,'unread')}"
                                                @click="jump_zhihu(item.Url,catalogtype,item.DataID,'unread','cancel')"><strong>{{item.Title}}</strong></span>
                                                <!-- <span style="float: right;padding-top: 4px;"><img src="../assets/image/cloud.png"></span> -->
                                            </p>
                                            <p class="page" style="padding-top: 5px;line-height: 20px;">
                                                <span class="desc" :class="{isread:!filter(item.Setting,'unread')}"
                                                @click="jump_zhihu(item.Url,catalogtype,item.DataID,'unread','cancel')">{{introlength(item.Desc)}}</span>
                                            </p>
                                            <p class="page desc" style="padding-top: 5px;" :class="{isread:!filter(item.Setting,'unread')}">

                                                <span style="padding-top: 8px;width: 30%;float: left;display: inline-block;">
                                                    <span >字数:{{item.WordCount}}</span>
                                                </span>
                                                <span style="margin-top: 8px;display: inline-block;padding-left: 5px;
                                                width:88px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">击中:{{item.HighlightWord}}</span>
                                                <span style="float: right;margin-top: 8px;display: inline-block">{{getCaption(item.AddTime,'T')}}</span>
                                            </p>
                                            <div class="page" style="padding-top: 2px;padding-bottom: 8px;">
                                                <span v-if="item" style="padding:2px 5px;border: 1px solid rgb(164, 156, 156);display:inline-block;margin-right: 5px;color:rgb(164, 156, 156);" v-for="item in filtertags(item.Tags,'showtgs')">
                                                    {{item}}
                                                </span>
                                            </div>

                                            <p class="titlehover" :id="'showid'+index">
                                                <span @click="operation(1,item.ProjectID,item.DataID,index)"><span><img v-if="filter(item.Setting,'favorites')" src="../assets/image/fullstar.png"><img v-else src="../assets/image/star.png"></span><span>收藏</span></span>
                                                <span @click="operation(2,item.ProjectID,item.DataID,index)"><span><img src="../assets/image/label.png"></span><span>标签</span></span>
                                                <span @click="operation(3,item.ProjectID,item.DataID,index)"><span><img src="../assets/image/del.png"></span><span v-if="showType!='1005'">删除</span><span v-else>撤销</span></span>
                                                <span title='复制文章链接' @click="copyurl(item.Url)"><span><img src="../assets/image/link.png"></span><span>链接</span></span>
                                            </p>

                                            <LabelList :id="'lab'+index" v-show="showLabel" :did="item.DataID" :savetags="filtertags(item.Tags,'')" :pid="item.ProjectID" v-on:listenTochildEvent="closelab(index)" v-on:listenTagsEvent="UpdateTags"></LabelList>
                                            <div class="dotted-line"></div>
                                        </div>
                                    </div>
                                    <div v-else class="nodata">
                                       <img src="https://s0.5118.com/assist/images/formal/nosearchicon.png">
                                        <p style="line-height: 25px;margin-left: -30px;">暂未发现{{gettabname(showType)}}知乎帖子</p>
                                    </div>
                                    <!--<SofaList :showType="showType"></SofaList> -->

                                </div>
                               <div v-loading="true" style="width:100%;height:50vh;position: relative;" v-if="showloading"></div>
                            </div>
                        </div>

                    </div>
                </template>
            </div>
        </div>


    </div>

</template>


<script>
    class Tab {
        constructor(name, code) {
        this.code = code;
        this.name = name;
        }
    }
    import {mapActions} from "vuex"
    import LabelList from "../components/LabelList";
    import SofaScr from "../components/SofaScreen";
    export default {
        name:"SofaSniper",
        watch: {
            showType(newVal) {
                if(newVal){
                    this.getdata(newVal,'');
                    this.allContentList=[];
                    this.ContentList=[];
                    this.showloading=true;
                }
            },
            query(newVal){
                if(newVal){
                    console.log(newVal);
                }
            },
            showlabid(newVal,oldVal){
                if(oldVal!=0)
                {
                    let islab = document.getElementById('lab'+oldVal);
                    if(islab)islab.style.display='none'
                }
            },
            jumptype(newVal){
                if(newVal==true){
                    this.allContentList=[];
                    this.ContentList=[];
                }
            }

        },
        components: {
            LabelList,
            SofaScr,
        },
        data(){
            return{
                projectshow:true,
                query:this.$route.query,
                keyword:'',
                showType: "1002",
                tabList: [new Tab("未读", "1002"), new Tab("已标签", "1003"), new Tab("收藏夹", "1004"),new Tab("全部", "1001"),  new Tab("回收站", "1005")],
                jumptype:false,
                showLabel:false,
                showlabid:0,
                showsofasearch:false,
                tagslist:[],
                projectstatus:-1,
                pageIndex:0,
                pageTotal:0,
                pageSize:0,
                allContentList:[],
                checkHightwords:'',
                rowcountlist:[],
                showLabing:false,
                optionstatrs:false,
                optionsmsg:'',
                NoList:true,
                showloading:true,
                showprojloading:true,
                hosturl:'https://zlb.5118.com',
                catalognumber:[],


            }
        },
        computed: {
            version:{
                get(){
                return this.$store.state.menu.version
                },
                set(val){
                this.$store.state.menu.version = val
                }
            },
            token:{
                get(){
                    return this.$store.state.menu.token
                },
                set(val){
                    this.$store.state.menu.token = val
                }
            },
            level:{
                get(){
                    return this.$store.state.menu.level
                },
                set(val){
                    this.$store.state.menu.level = val
                }
            },
            ContentList:{
                get(){
                    return this.$store.state.sofasniper.ContentList
                },
                set(val){
                    this.$store.state.sofasniper.ContentList = val
                }
            },
            catalogList:{
                get(){
                    return this.$store.state.sofasniper.catalogList
                },
                set(val){
                    this.$store.state.sofasniper.catalogList = val
                }
            },
            catalogtype:{
                get(){
                    return this.$store.state.sofasniper.catalogtype
                },
                set(val){
                    this.$store.state.sofasniper.catalogtype = val
                }
            },
            CatalogName:{
                get(){
                    return this.$store.state.sofasniper.CatalogName
                },
                set(val){
                    this.$store.state.sofasniper.CatalogName = val
                }
            },
            rowcountnew:{
                get(){
                    return this.$store.state.sofasniper.rowcountnew
                },
                set(val){
                    this.$store.state.sofasniper.rowcountnew = val
                }
            },
            ShowTagsList:{
                get(){
                    return this.$store.state.sofasniper.ShowTagsList
                },
                set(val){
                    this.$store.state.sofasniper.ShowTagsList = val
                }
            },
            loginBox:{
                get() {
                return this.$store.state.header.loginBox
                }, set(val) {
                this.$store.state.header.loginBox = val
                }
            },
        },
        mounted() {
            this.ASetHistory("sofasniper").then(flag => {
                if(this.version.replace(/\./gi, '') >= 203){
                    this.listening();
                }
                else{
                     this.showprojloading=false;
                }
            });
        },
        methods: {
            ...mapActions("menu", ["ASetHistory"]),

            jumplist(pid,name,type,stype,other){
                this.showLabing=false;
                let sendmsg={projectid:pid,token:this.token,projecttype:type,other:other}
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Sofa_Sniper_Catalog_Info_Message",sendmsg);
                this.catalogtype=pid;
                this.CatalogName=name;
                if(stype==''){
                    this.showType='1002';
                    this.$messenger.addTarget(window.parent, 'parent');
                    let sendmsg={token:this.token,projectid:pid}
                    this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Project_Tag_Message",sendmsg);
                }
                this.jumptype=true;
                for(let i in this.catalogList){
                    if(this.catalogList[i]['ProjectID']==this.catalogtype){
                        this.catalogList[i]['NewCount']=0;
                        this.catalogList[i]['DataCount']=this.catalogList[i]['OldCount']
                    }
                }
            },
            getrowcount(pid){
                for(let i in this.catalogList){
                    if(this.catalogList[i]['ProjectID']==pid){
                        if(Number(this.catalogList[i]['NewCount']>0)){
                            let rowcount=this.catalogList[i]['NewCount'];
                            return rowcount;

                        }
                    }
                }
                return 0;
            },
            getcatalognumber(index){
                if(index==='1001'){
                    return this.catalognumber.allCount
                }
                if(index==='1002'){
                    return this.catalognumber.unreadCount
                }
                if(index==='1003'){
                    return this.catalognumber.tagsCount
                }
                if(index==='1004'){
                    return this.catalognumber.favoritesCount
                }
                if(index==='1005'){
                    return this.catalognumber.recoveryCount
                }

            },
            ScreenClose(retmsg){
                this.showsofasearch=retmsg;
            },
            SendScreenMsg(msg){
                this.ContentList=[];
                this.showloading=true;
                this.getdata(this.showType,msg);
                // this.showType='1001';
                this.showsofasearch=false;

            },
            allgetdata(pid,name,type,status){
                this.projectstatus=status;
                this.ContentList=[];
                this.showloading=true;
                this.jumplist(pid,name,'unread',type,'')
            },
            gettabname(type){
                switch (type) {
                    case '1001':
                        return '全部'
                        break;
                    case '1002':
                        return '未读'
                        break;
                    case '1003':
                        return '已标签'
                        break;
                    case '1004':
                        return '收藏夹'
                        break;
                    case '1005':
                        return '回收站'
                        break;
                    default:
                        break;
                }
            },
            copyurl(url){
                let textarea = document.createElement("input");
                textarea.value = url;
                textarea.style.transform = "translateY(-9999px)";
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("Copy");
                this.showmsg('文章链接复制成功');
            },

            jumpproject(type){
                if(this.token){
                    switch (type) {
                        case 1:
                            this.jumpciliuti(this.hosturl+'/PlugInlogin?token='+this.token+'&level='+this.level+'&returnurl='+this.hosturl+'/sniper/create');
                            break;
                        case 2:
                            this.jumpciliuti(this.hosturl+'/PlugInlogin?token='+this.token+'&level='+this.level+'&returnurl='+this.hosturl+'/sniper/projectList');
                            break;
                        case 3:
                            this.jumpciliuti(this.hosturl+'/PlugInlogin?token='+this.token+'&level='+this.level+'&returnurl='+this.hosturl+'/sniper/setting/'+this.catalogtype);
                            break;
                        case 4:
                            this.jumpciliuti(this.hosturl+'/PlugInlogin?token='+this.token+'&level='+this.level+'&returnurl='+this.hosturl+'/sniper/pay/'+this.catalogtype);
                            break;
                        case 5:
                            this.jumpciliuti(this.hosturl+'/PlugInlogin?token='+this.token+'&level='+this.level+'&isHttpRequest=true');
                            break;
                        default:
                            break;
                    }
                }
                else{
                    if(this.loginBox){
                        this.loginBox.close();
                        this.loginBox = null
                    }
                    this.loginBox = this.$loginBox();
                }

            },
            gobackmain(){
                this.jumptype=false;
                this.ContentList=[];
                this.pageIndex=0;
                this.catalogtype='';
                this.CatalogName='';
                this.pageTotal=0;
                this.pageSize=0;
                this.allContentList=[];
                this.showLabing=false;
                this.showloading=true;
            },
            getstatus(status,step,pid){
                if(step!=5){
                        return '未设置'
                    }
                if(status==2)return '已到期'
                if(status==0)
                {
                    return '未付费'
                }

            },
            jumpciliuti(url){
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Sofa_Sniper_jumpciliuti_Message",url);
            },
            getscroll(e){
                if(this.jumptype){
                    if(this.pageIndex==0)return
                    let scrollTop = e.srcElement.scrollTop;
                    let offsetHeight = e.srcElement.offsetHeight;
                    let scrollHeight = e.srcElement.scrollHeight;
                    if(scrollTop+offsetHeight>=scrollHeight){
                        let AllPages = Math.ceil(this.pageTotal / this.pageSize);
                        this.pageIndex+=1;
                        if(this.pageIndex<=AllPages)
                            this.getdata(this.showType,'&PageIndex='+this.pageIndex)

                    }
                }
            },
            filtertags(str,type){
                let items=str.split('|');
                if(type=='showtgs')
                    items.splice(3,)
                return items;
            },
            filter(str,name){
                let items = str.split('|');
                for(let item of items)
                {
                    if(item==name)
                    {
                        return true
                    }
                }
                return false
            },
            getCaption(obj,str){
                let index=obj.lastIndexOf(str);
                obj=obj.substring(0,index);
                return obj;
            },
            checkkeywords(){
                this.ContentList=[];
                this.showloading=true;
                this.getdata(this.showType,'&keyword='+this.keyword)
                // this.jumplist(this.catalogtype,this.CatalogName,'','','&keyword='+this.keyword)
                // this.keyword=''
            },
            checkrefresh(){
                this.allContentList=[];
                this.ContentList=[];
                this.getdata(this.showType,'')
            },
            introlength(str){
                if(String(str).length>35){
                    str=str.substring(0, 35)+'...';
                    return str
                }
                return str
            },
            getdata(codeid,other){
                switch (codeid) {
                    case '1001':
                        this.jumplist(this.catalogtype,this.CatalogName,'',codeid,other)
                        break;
                    case '1002':
                        this.jumplist(this.catalogtype,this.CatalogName,'unread',codeid,other)
                        break;
                    case '1003':
                        this.jumplist(this.catalogtype,this.CatalogName,' tags',codeid,other)
                        break;
                    case '1004':
                        this.jumplist(this.catalogtype,this.CatalogName,'favorites',codeid,other)
                        break;
                    case '1005':
                        this.jumplist(this.catalogtype,this.CatalogName,'recovery',codeid,other)
                        break;
                    default:
                        break;
                }
            },
            listening(){
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Message",this.token);

                setInterval(() => {
                    this.$messenger.addTarget(window.parent, 'parent');
                    this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Message",this.token);
                }, 120000);

                this.$messenger.listen("_5118_Sofa_Sniper_GetProject_Tag_info", (msg) => {
                    if(msg)
                    {
                        this.ShowTagsList=JSON.parse(msg);
                        if(msg.indexOf('已作答')==-1){
                            this.ShowTagsList.push({Name:'已作答'});
                        }
                        if(msg.indexOf('不相关')==-1){
                            this.ShowTagsList.push({Name:'不相关'});
                        }

                    }
                });

                // let stiem=0;
                this.$messenger.listen("_5118_Sofa_Sniper_CatalogList_info", (msg) => {
                    if(msg==="null")
                    {
                        this.projectshow=false;
                    }
                    else if(JSON.parse(msg).length>0)
                    {
                        this.catalogList=[];
                        this.projectshow=true;
                        msg=JSON.parse(msg);

                        for(let item of msg){
                            item['isnew']=false;
                            item['NewCount']=item['NewDataCount'];
                            item['OldCount']=item['DataCount'];
                            this.catalogList.push(item)
                        }

                        // if(this.catalogList.length<=0)
                        // {
                        //     for(let item of msg){
                        //         item['isnew']=false;
                        //         item['NewCount']=item['NewDataCount'];
                        //         item['OldCount']=item['DataCount'];
                        //         this.catalogList.push(item)
                        //     }
                        // }
                        // else{
                        //     for(let i=0;i<msg.length;i++){
                        //         let projectid=msg[i]['ProjectID'];
                        //         let getnew=true;
                        //         for(let j in this.catalogList){
                        //             let newprojectid=this.catalogList[j]['ProjectID'];
                        //             if(newprojectid==projectid){

                        //                 if (this.catalogList[j]['DataCount']!=msg[i]['DataCount']){
                        //                     this.catalogList[j]['NewCount']=msg[i]['NewDataCount'];
                        //                     this.catalogList[j]['OldCount']=msg[i]['DataCount'];
                        //                 }
                        //                 this.catalogList[j]['EndTime']=msg[i]['EndTime'];
                        //                 this.catalogList[j]['ProjectName']=msg[i]['ProjectName'];
                        //                 this.catalogList[j]['EndDay']=msg[i]['EndDay'];
                        //                 this.catalogList[j]['MonitorStatus']=msg[i]['MonitorStatus'];
                        //                 this.catalogList[j]['Step']=msg[i]['Step'];

                        //                 getnew=false;
                        //             }
                        //         }
                        //         if(getnew){
                        //             msg[i]['isnew']=false;
                        //             msg[i]['NewCount']=0;
                        //             msg[i]['OldCount']=msg[i]['DataCount'];
                        //             this.catalogList.unshift(msg[i]);
                        //         }
                        //     }
                        // }
                        // for(let i in this.catalogList){
                        //     if(this.catalogList[i]['NewCount']>0){
                        //         this.rowcountnew=true;
                        //     }
                        //     else{
                        //         this.rowcountnew=false;
                        //     }
                        // }
                    }
                    else
                    {
                        this.projectshow=false;
                    }
                    this.showprojloading=false;
                });

                this.$messenger.listen("_5118_Sofa_Sniper_CatalogDataList_info", (msg) => {
                    msg=JSON.parse(msg);
                    this.allContentList=[];
                    if(msg.Result.length>0)
                    {
                        this.NoList=true;
                        this.pageIndex =msg.PageIndex;
                        this.pageTotal = msg.Total;
                        // this.ContentList=msg.Result;
                        this.allContentList=msg.Result;
                        this.pageSize=msg.PageSize;
                        this.checkHightwords = msg.RelatedWords;
                        for(let item of this.allContentList){
                            let isok=true;
                            for(let items of this.ContentList){
                                if(item.Url==items.Url){
                                    isok=false;
                                }
                            }
                            if(isok){
                                this.ContentList.push(item)
                            }

                        }

                        for(let item of this.catalogList)
                        {
                            if(item.ProjectID==this.ContentList[0].ProjectID){
                                this.projectstatus=item.MonitorStatus;
                            }
                        }

                    }
                    else{
                        this.NoList=false;
                    }

                    this.showloading=false;
                });

                this.$messenger.listen("_5118_Ciliuti_Send_Project_Message", (msg) => {
                    this.gobackmain();
                    this.$messenger.addTarget(window.parent, 'parent');
                    this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Message",this.token);

                });

                this.$messenger.listen("_5118_Ciliuti_Send_Project_Count_Message", (msg) => {
                    this.catalognumber=JSON.parse(msg);

                });


            },
            jump_zhihu(url,projectid,dataid,operateStatus,operatetype){
                let sendmsg={url:url,projectid:projectid,dataid:dataid,operateStatus:operateStatus,operatetype:operatetype,token:this.token,checkhightwords:this.checkHightwords}
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_jumpurl_Message",sendmsg);
                this.operation(4,projectid,dataid,'')

                // for(let i in this.ContentList)
                // {
                //     if(this.ContentList[i].DataID==dataid)
                //     {
                //         this.ContentList.splice(i,1);
                //     }
                // }

            },
            showoperation(showid)
            {
                if(!this.showLabing){
                    let getid=document.getElementById('showid'+showid);
                    getid.style.display='block';
                }

            },
            closeoperation(showid){
                if(!this.showLabing){
                    let getid=document.getElementById('showid'+showid);
                    getid.style.display='none';
                    let islab = document.getElementById('lab'+showid);
                    if(islab)islab.style.display='none'
                }

            },
            operation(type,pid,did,indexid){
                if(type===1)
                {
                    for(let i in this.ContentList)
                    {
                        if(this.ContentList[i].DataID==did)
                        {
                            if(String(this.ContentList[i].Setting).indexOf('favorites')==-1)
                            {
                                this.ContentList[i].Setting='favorites';
                                let sendmsg={projectid:pid,dataid:did,operateStatus:'favorites',operatetype:'set',token:this.token}
                                this.$messenger.addTarget(window.parent, 'parent');
                                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Setting_Message",sendmsg);
                            }
                            else
                            {
                                this.ContentList[i].Setting=String(this.ContentList[i].Setting).replace('favorites','');
                                let sendmsg={projectid:pid,dataid:did,operateStatus:'favorites',operatetype:'cancel',token:this.token}
                                this.$messenger.addTarget(window.parent, 'parent');
                                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Setting_Message",sendmsg);
                            }
                        }
                    }
                }
                if(type===2)
                {
                    this.showlabid=did;
                    let islab = document.getElementById('lab'+indexid);
                    if(islab)islab.style.display='block'
                    this.showLabing=true;
                }
                if(type===3)
                {
                    for(let i in this.ContentList)
                    {
                        if(this.ContentList[i].DataID==did)
                        {
                            if(String(this.ContentList[i].Setting).indexOf('recovery')==-1)
                            {
                                this.ContentList.splice(i,1);

                                let sendmsg={projectid:pid,dataid:did,operateStatus:'recovery',operatetype:'set',token:this.token}
                                this.$messenger.addTarget(window.parent, 'parent');
                                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Setting_Message",sendmsg);
                            }
                            else
                            {
                                this.ContentList.splice(i,1);
                                let sendmsg={projectid:pid,dataid:did,operateStatus:'recovery',operatetype:'cancel',token:this.token}
                                this.$messenger.addTarget(window.parent, 'parent');
                                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_Setting_Message",sendmsg);
                            }

                        }
                    }
                }
                if(type===4)
                {
                    for(let i in this.ContentList)
                    {
                        if(this.ContentList[i].DataID==did)
                        {
                            this.ContentList[i].Setting=String(this.ContentList[i].Setting).replace('unread','');
                        }
                    }
                }
            },
            closelab(id){
                let islab = document.getElementById('lab'+id);
                if(islab)islab.style.display='none'
                this.showLabing=false;
            },
            sofasearch(){
                this.showsofasearch=true;
            },
            allread(){
                let sendmsg={projectid:this.catalogtype,token:this.token}
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Sofa_Sniper_Send_AllRead_Message",sendmsg);
                if(this.showType=='1002'){
                    this.ContentList=[];
                }
                this.showmsg('全部已读设置成功');

            },
            UpdateTags(msg)
            {
                for(let i in this.ContentList)
                {
                    if(this.ContentList[i].DataID==msg.did)
                    {
                        this.ContentList[i].Tags=msg.tags;
                    }
                }
                this.showmsg('文章标签设置成功');
            },
            showmsg(msg){
                this.optionsmsg=msg;
                this.optionstatrs=true;
                setTimeout(() => {
                    this.optionstatrs=false;
                }, 2000);
            }

        }
    }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";
  ._sofasniper_title{
      font-size: 12px;
    p{
        line-height: 25px;
        color: gray;
    }
  }
  ._sofasniper_list{
      font-size: 12px;
      border: 2px solid #f2f0f0;
      padding: 10px;
      margin-top: 10px;
      ._projcet_name{
          font-size: 14px;
          color:black;
      }
      ._project_num{
          padding-top: 10px;
          color: gray;
      }
      ._project_msg{
          position: absolute;
          margin-left: 140px;
          margin-top: -30px;
          color: gray;
          font-size: 13px;
          &.active{
                color: #f49307;
            }
      }
  }

  .stab{
        font-size: 12px;
        .newbtn{
            background-color: #f6f6f6;
            width: 30px;
            height: 30px;
            display: inline-block;
            position: absolute;
            img{
                position: absolute;
                margin: 7px 7px;
            }
        }
        .tab {
            display: table;
            width: 100%;
            // background-color: #ebf2fe;
            line-height: 32px;
            margin: 0;
            border-bottom: 1px solid lightgray;
            border-top: 1px solid lightgray;
            .tab-item {
                list-style: none;
                float: left;
                width: 20%;
                text-align: center;
                cursor: pointer;
                color: #666;
                margin: 0;
                line-height: 17px;
                padding: 2px;
                &.active {
                    border-bottom: 2px solid @theme-color;
                //background-color: white;
                color: @theme-color
                }
            }
        }
        .artlist{
            padding-top: 10px;
            .headerimg{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background-size:auto 30px;
            }
            .readimg{
                position: absolute;
                margin-top: 20px;
                margin-left: -10px;
            }
            .ctitle{
                display :inline-block ;
                width: 65%;
                overflow: hidden;
                position: absolute;
                font-size: 13px;
                padding-top: 10px;
                color: black;
                cursor: pointer;
            }
            .desc{
                color: black;
                font-size: 12px;
                cursor: pointer;
            }
            .icon-zhihu{
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAADBElEQVQ4jXWUTWicVRSGn/fM981PkhnTn7QYbMAIU6sVVJRqyCoIUl0Uu7OrLkpBdOGyG3UbFQRdFKogLvzpqkWR4j+lkBQXEX8wloYatVpbgq2Jmcx8M9+9x8VkkjHggcvl3nvOufe873uuqtM3EY4TAENycA4Az0hMRbTHgoNxzeE8cErSheAguiYcbUm0S/Kz7kz0nP7HvnV0CPitl8j6DvfjfiM4E/9k0I7gDs6W0d27X/ivwKO94GR9Hhb8kDusZZH6driyLFodUAKJQSfzzStNDJYMk8+6tEfw+/qL/JPosNZyxreJmaMDVOSUEzFgkEcY21agviulPpKyu2ZkAaKD4V8CJCJ/BHTAHWg6xx4ssbM6wOLzKdWicebHFqfnO3x4pMrPy4EdZaNoMPzKMlmAilSXcdAcexYgd1GuFTg4nrDvjb9Y+Dtw/NwqR95usH3I+OJKxl0nblF//SbuUE5EiBvlPmfCp9bLJknh4bdWuTSX4wG+ux5gKdLuOO1ogNGIohUcB9QTgDOZRDRqdKlo5pGXHyuxd0fCxFjCu09VOLc/YSWDVt6lplgwTHFDQ9EjBVnNjE02KgbfXHdOX4o0cnhtNufMfGQth1TeRRfAN1Vjsh6R8QZ0KQ4u3p9p895ci8HE2VkOfP1Vxh8rkdwdMudWI5LFrfpUw1x2vreMXdQ5dajC5wttDu8r8sKxCp2OcfdISmG0wEuTJXYPiuARCWRChIuGc5J11WZN5+hUkeMPVXj6bJPJd5qMDIoLV3NuSwPZi1UeuKPIqzMtmrlITbg7uJ1UbXoJh+87gftS5bz55AAfXQ58MJdDiW5ndmB0ODBUKnB5MUJRlGsiMQG6ivuYqtNLpDG/PVfhWsBoNCMEpzIkDBEiJILVHAhQKXWlYoDkuKuOs9DrtT8RE+bMDlW0oRAJCoWuQ7W4DusGwE5bxcdTby+ANrtfcFFi3MRPZkL670ei/iTyX1x2r+CzDRn0OzssOtxjHp4Q4WNguY/RFeGfIjvs0e4En++P/RebvUtoZvyTLgAAAABJRU5ErkJggg==) no-repeat 0;
            }
            .icons{
                display: inline-block;
                height: 30px;
                width: 30px;
                vertical-align: text-bottom;
            }
            .titlehover{
                display: none;
                height: 30px;
                background-color: aliceblue;
                padding: 6px;
                // text-align: center;
                font-size: 13px;
                position: relative;
                margin-top: -34px;
                span{
                    margin-left: 9px;
                    cursor: pointer;
                }
                img{
                    width: 15px;
                    height: 15px;
                    position: absolute;
                    margin-top: 2px;
                    margin-left: -7px

                }
            }
            .isread{
                color: #999
            }

        }
        .nodata{
            position: fixed;
            height: calc(100%);
            width: 100%;
            margin-top: 50%;
            margin-left: 100px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/SofaSniper.vue